<template>
  <div>
    <FilterTab>
      <template v-slot:body>
        <div class="col-sm-6 col-md-2">
          <DropdownFilter
            :id="'reporttype'"
            :label="'Report Type'"
            :defaultOption="'--select report type--'"
            v-model="printCountReport.reportType"
            :defaultValue="''"
            :dropdown="dropdownVariables.reportType"
          />
        </div>
        <div
          v-if="printCountReport.reportType !== 'dailySummaryReport'"
          class="col-sm-6 col-md-4"
        >
          <DateTimeRangePicker v-model="date.range" />
        </div>
        <div v-else class="col-sm-6 col-md-2 text-white">
          <DatePickerFilter
            v-model="printCountReport.summaryDate"
            :id="'countdate'"
            :label="'Report Count Date'"
          >
          </DatePickerFilter>
        </div>
      </template>
      <template v-slot:button2>
        <button class="edit_table_data font_detail" @click="filterCountReport">
          <i class="fas fa-filter"></i><span class="mx-1 bold">Filter</span>
        </button>
      </template>
      <template v-slot:button1>
        <button
          class="edit_table_data font_detail"
          @click="exportExcel('xlsx')"
        >
          <i class="fas fa-download"></i><span class="mx-1 bold">Export</span>
        </button>
      </template>
    </FilterTab>
    <!-- {{ $store.getters.getPrintTicketCountListOwner }}
    {{ $store.getters.getPrintTripWiseCountListOwner }}
    {{ $store.getters.getPrintDailySummaryWiseCountListOwner }} -->
    <TicketPrintCount v-if="printCountReport.reportType === 'ticket'" />
    <TripWisePrintCountReport
      v-if="printCountReport.reportType === 'tripWiseReport'"
    />
    <DailySummaryReport
      v-if="printCountReport.reportType === 'dailySummaryReport'"
    />
    <SupervisorTripWiseReport
      v-if="printCountReport.reportType === 'supervisorTripWiseReport'"
    />
  </div>

  <router-view></router-view>
</template>

<script>
import DateTimeRangePicker from "@/components/layouts/Filter/Inputs/DateTimeRangePicker";
import DropdownFilter from "@/components/layouts/Filter/Inputs/Dropdown";
import TicketPrintCount from "./TicketPrintCount.vue";
import TripWisePrintCountReport from "./TripWisePrintCountReport.vue";
import SupervisorTripWiseReport from "./SupervisorTripWiseReport.vue";
import DailySummaryReport from "./DailySummaryReport.vue";
import dropdownVariables from "@/modules/dropdownVariables";
import { reactive } from "@vue/reactivity";
import moment from "moment";
import { onBeforeMount, watch } from "vue";
import store from "@/store";
import XLSX from "xlsx";

export default {
  name: "PrintCountReport",
  components: {
    DateTimeRangePicker,
    DropdownFilter,
    TicketPrintCount,
    TripWisePrintCountReport,
    SupervisorTripWiseReport,
    DailySummaryReport,
  },

  setup() {
    const fromDate = moment(new Date()).format("yyyy-MM-DD" + " 00:00:00");
    const toDate = moment(new Date()).format("yyyy-MM-DD" + " 23:59:59");
    const today = moment(new Date()).format("yyyy-MM-DD");

    let date = reactive({
      range: {
        start: fromDate,
        end: toDate,
      },
    });

    let printCountReport = reactive({
      reportType: "",
      fromDate: "",
      toDate: "",
      summaryDate: "",
      page: 1,
      limit: 10,
    });

    watch(
      () => date.range.start,
      (date) => {
        printCountReport.fromDate = date;
      }
    );
    watch(
      () => date.range.end,
      (date) => {
        printCountReport.toDate = date;
      }
    );

    const filterCountReport = () => {
      store.dispatch("getPrintCountListOwner", printCountReport).then(() => {});
    };

    onBeforeMount(() => {
      printCountReport.fromDate = fromDate;
      printCountReport.toDate = toDate;
      printCountReport.summaryDate = today;
    });

    const exportExcel = (type, fn, dl) => {
      if (document.getElementById("exportable_data") !== null) {
        var elt = document.getElementById("exportable_data");
        var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet Js" });
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(
              wb,
              fn || "Owner_CounterWise_Report." + (type || "xlsx")
            );
      }
    };

    return {
      dropdownVariables,
      date,
      printCountReport,
      filterCountReport,
      exportExcel,
    };
  },
};
</script>

<style scoped>
</style>